import { withAITracking } from '@microsoft/applicationinsights-react-js';
import React, { Fragment } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { ai, reactPlugin } from '../services';

interface TelemetryProviderProps {
  instrumentationKey: string;
}

interface TelemetryProviderState {
  initialized: boolean;
}

// Register app insights client
class TelemetryProvider extends React.Component<TelemetryProviderProps & RouteComponentProps, TelemetryProviderState> {
  constructor(props: TelemetryProviderProps & RouteComponentProps) {
    super(props);

    this.state = {
      initialized: false
    };
  }

  componentDidMount(): void {
    const { history } = this.props;
    const { initialized } = this.state;
    const AppInsightsInstrumentationKey = this.props.instrumentationKey;
    if (!initialized && AppInsightsInstrumentationKey && history) {
      ai.initialize(AppInsightsInstrumentationKey, history);
      this.setState({ initialized: true });
    }
  }

  render(): JSX.Element {
    const { children } = this.props;
    return <Fragment>{children}</Fragment>;
  }
}

export default withRouter(withAITracking(reactPlugin, TelemetryProvider, 'telemetryProvider', 'h-100'));
